import {
  DANCER,
  SINGER,
  MUSICIAN,
  REGISSEUR,
  COSTUME,
  LIGHTING,
  COMPOSER,
  CONDUCTOR,
  MAKEUP,
  STAGE_DESIGNER,
  CHOREOGRAPHER,
  MANAGER,
  MULTIMEDIA,
} from '../constants';

export default (key) => {
  switch (key) {
    case DANCER:
      return 'Bailarín / Dancer';
    case SINGER:
      return 'Cantante / Singer';
    case MUSICIAN:
      return 'Músico / Musician';
    case REGISSEUR:
      return 'Regisseur / Stage director';
    case COSTUME:
      return 'Vestuarista / costume designer';
    case LIGHTING:
      return 'Iluminación / Lighting designer';
    case COMPOSER:
      return 'Compositor / Composer';
    case CONDUCTOR:
      return 'Director de orquesta / conductor';
    case MAKEUP:
      return 'Maquillador / Makeup artist';
    case STAGE_DESIGNER:
      return 'Escenógrafo / Stage Designer';
    case CHOREOGRAPHER:
      return 'Coreografo / choreographer';
    case MANAGER:
      return 'Gestor Cultural / Art Manager';
    case MULTIMEDIA:
      return 'Multimedia / Audiovisual';
    default:
      return key;
  }
};



// WEBPACK FOOTER //
// ./src/transforms/KeyToProfession.js